// app/javascript/recipes/filtering/triggers/difficulty.js

import actions from '../actions';
import onReady from '../../../../helpers/onReady'

onReady(() => {
  document.addEventListener('click', (e) => {
    let target;
    if (e.target.classList.value.includes('ui label')) target = e.target;
    if (e.target.classList.value.includes('delete icon filter')) target = e.target.parentNode;
    if (target == null) return false;
    if (target.getAttribute('data-classname') !== 'difficulty') return true;
    actions.difficulty.reinitializeDifficulty();
    actions.global.getFilteredRecipes('replace');
    target.remove();
    return true;
  });
});
